import React, { Component } from "react";
import "./style.css";
class ReturnTop extends Component {
  render() {
    const { visible } = this.props;
    return (
      <div
        className={visible === true ? "list_top" : "list_top display_none"}
        onClick={() => this.handleListTop()}
      >
        <img alt="" src={require("../../images/school/top.png")}></img>
      </div>
    );
  }
  handleListTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };
}

export default ReturnTop;



// WEBPACK FOOTER //
// ./src/components/ReturnTop/index.js